import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, arrayOf, shape, string } from "prop-types";
import { isIOS } from "react-device-detect";
import { push } from "connected-react-router";
import classNames from "classnames";
import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";
import PageLoading from "pages/_components/PageLoading";
import Notification from "pages/_components/Notification";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import GridTable from "pages/_components/GridTable/GridTable";
import Container from "pages/_components/Container";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import MainContainer from "pages/_components/MainContainer";
import Col from "react-bootstrap/lib/Col";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import "styles/components/modules/_listAccounts.scss";

class ListAccounts extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        accountsInfo: arrayOf(
            shape({
                accountNumber: string.isRequired,
                name: string,
                phone: string,
                mail: string,
            }),
        ),
    };

    static defaultProps = {
        accountsInfo: [],
    };

    state = {
        isDesktop: typeof window !== "undefined" ? window.innerWidth > 1024 : true,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(investmentfundsActions.listAccounts());
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ isDesktop: window.innerWidth > 1024 });
    };

    emptySection = () => {
        const { dispatch } = this.props;

        return (
            <MainContainer className="main-container">
                <Grid className="form-content">
                    <Row className="justify-content-center">
                        <div className="illustration text-center">
                            <Image src="images/figma/illustrations/advertisement.svg" className="svg-image logo" />
                            <div className="pb-6" />
                            <Col xs={12} md={10} mdOffset={1}>
                                <div className="font-bold">
                                    <I18n id="investmentFunds.add.account.noAccount" />
                                </div>
                            </Col>
                        </div>
                    </Row>

                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={4}>
                            <div className="toolbar-item add-button" key="add">
                                <CustomButton
                                    func={() => dispatch(push("/investmentFunds/accounts/noProfileInfo"))}
                                    className="btn btn-primary btn-block"
                                    icon="images/figma/icon/nuevo.svg"
                                    text="investmentFunds.myAccounts.requestAccount"
                                    textType="I18N"
                                />
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </MainContainer>
        );
    };

    render() {
        const { fetching, accountsInfo, dispatch } = this.props;
        const { isDesktop } = this.state;
        const safeAccounts = Array.isArray(accountsInfo) ? accountsInfo : [];
        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                <CustomProductHead
                    titleId="activities.investmentFunds.myAccounts.list"
                    backLinkTo="/holdings"
                    addLinkToLabel="activities.investmentFunds.myAccounts.addAccount"
                    className="deposits">
                    <div className="toolbar-item view-title">
                        <ViewTitle id="activities.investmentFunds.myAccounts.list" />
                    </div>
                </CustomProductHead>

                {!accountsInfo || accountsInfo.length === 0 ? (
                    this.emptySection()
                ) : (
                    <MainContainer className="main-container">
                        <GridTable className={classNames("investments-list-accounts")}>
                            {safeAccounts.map(({ accountNumber, name, phone, mail }) =>
                                (isDesktop ? (
                                    // --- DESKTOP: SIN CAMBIOS ---
                                    <GridTable.Container
                                        key={accountNumber}
                                        rowId={accountNumber}
                                        columns={6}
                                        className={classNames("gap-5", { "mb-5": isIOS })}
                                        styles={{
                                            gridTemplateColumns: "2fr 1fr 1fr 2fr 1fr auto",
                                            gridAutoRows: "auto",
                                        }}>
                                        <GridTable.Data
                                            columnStart={1}
                                            rowStart={1}
                                            alignX="flex-start"
                                            alignY="center">
                                            <CustomData
                                                dataClass="accounts-account-list-data"
                                                titleText="activities.investmentFunds.myAccounts.name"
                                                titleTextType="I18N"
                                                valueText={name}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnStart={2}
                                            rowStart={1}
                                            alignX="flex-start"
                                            alignY="center">
                                            <CustomData
                                                dataClass="accounts-account-list-number"
                                                titleText="activities.investmentFunds.myAccounts.accountNumber"
                                                titleTextType="I18N"
                                                valueText={`Nº ····${accountNumber.slice(-4)}`}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnStart={3}
                                            rowStart={1}
                                            alignX="flex-start"
                                            alignY="center">
                                            <CustomData
                                                dataClass="accounts-account-list-data"
                                                titleText="activities.investmentFunds.myAccounts.summary"
                                                titleTextType="I18N"
                                                valueText="Mensual"
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnStart={4}
                                            rowStart={1}
                                            alignX="flex-start"
                                            alignY="center">
                                            <CustomData
                                                dataClass="accounts-account-list-data"
                                                titleText="activities.investmentFunds.myAccounts.mail"
                                                titleTextType="I18N"
                                                valueText={mail}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            columnStart={5}
                                            rowStart={1}
                                            alignX="flex-start"
                                            alignY="center">
                                            <CustomData
                                                dataClass="accounts-account-list-data"
                                                titleText="activities.investmentFunds.myAccounts.phone"
                                                titleTextType="I18N"
                                                valueText={phone}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnStart={6} rowStart={1} alignX="flex-end" alignY="center">
                                            {/* acciones futuras */}
                                        </GridTable.Data>
                                    </GridTable.Container>
                                ) : (
                                    // --- MOBILE: NUEVO LAYOUT APILADO ---
                                    <div key={accountNumber} className="investments-list-accounts__card">
                                        <CustomData
                                            dataClass="accounts-account-list-data"
                                            titleText="activities.investmentFunds.myAccounts.name"
                                            titleTextType="I18N"
                                            valueText={name}
                                        />
                                        <CustomData
                                            dataClass="accounts-account-list-number"
                                            titleText="activities.investmentFunds.myAccounts.accountNumber"
                                            titleTextType="I18N"
                                            valueText={`Nº ····${accountNumber.slice(-4)}`}
                                        />
                                        <CustomData
                                            dataClass="accounts-account-list-data"
                                            titleText="activities.investmentFunds.myAccounts.summary"
                                            titleTextType="I18N"
                                            valueText="Mensual"
                                        />
                                        <CustomData
                                            dataClass="accounts-account-list-data"
                                            titleText="activities.investmentFunds.myAccounts.mail"
                                            titleTextType="I18N"
                                            valueText={mail}
                                        />
                                        <CustomData
                                            dataClass="accounts-account-list-data"
                                            titleText="activities.investmentFunds.myAccounts.phone"
                                            titleTextType="I18N"
                                            valueText={phone}
                                        />
                                        <div className="investments-list-accounts__actions" />
                                    </div>
                                )),
                            )}
                        </GridTable>

                        <Container className="items-center container--layout">
                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                <div className="toolbar-item add-button" key="add">
                                    <CustomButton
                                        func={() => dispatch(push("/investmentFunds/accounts/noProfileInfo"))}
                                        className="btn btn-primary btn-block"
                                        icon="images/figma/icon/nuevo.svg"
                                        text="activities.investmentFunds.myAccounts.addAccount"
                                        textType="I18N"
                                    />
                                </div>
                            </Col>
                        </Container>
                    </MainContainer>
                )}
            </PageLoading>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    accountsInfo: investmentfundsSelectors.getAccountsInfo(state) || [],
});
export default connect(mapStateToProps)(ListAccounts);
